module.exports = __webpack_public_path__ + "img/error-dark.3baa0acd.svg";